import { logApiError } from "@/lib/client/errors";
const API_URL = process.env.NEXT_PUBLIC_API_URL || "";

/**
 * Translates text via the backend and strips leftover URL-encoded artifacts
 * (%20 etc.) from scraped listings. Returns the cleaned translated text, or
 * null when the request fails or yields nothing so callers can tell a
 * failure apart from a translation.
 */
export const translateText = async (text: string, to = "en"): Promise<string | null> => {
  const endpoint = "/api/v2/translate";
  try {
    const params = new URLSearchParams({ text, to });
    const res = await fetch(`${API_URL}${endpoint}?${params}`, {
      credentials: "include",
    }).then((res) => res.json());
    const translated = res?.data?.text;
    if (typeof translated !== "string" || translated === "") {
      logApiError(new Error("Translate API returned no text"), endpoint, { to });
      return null;
    }
    return translated.replace(/%[0-9A-F]{2}/gi, " ");
  } catch (error) {
    logApiError(error, endpoint, { text, to });
    return null;
  }
};
